import AppService from "./AppService";
import { getUserEmail, appLogOutHandler } from "./UserAccessToken";

export async function logout(callback, data) {
    const email = getUserEmail();
    const user = email.substring(0, email.indexOf('@'));

    // used to check if there are any open dashboards and stop the RDS for those instruments
    Object.keys(data).filter(key => key.match(/^\d+$/) !== null).forEach(key => {
        AppService.postData({ user }, data[key].rdsUrl + "/stopRDS");
    });

    // used to store this token in the invalid tokens table and then logout from msal
    AppService.postData({}, process.env.APP_SERVICE + "/applogout", appLogOutHandler);
    
    if (callback) {
        callback();
    }
};
